import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Inline table placeholder dropped into a page's content area while its rows
// load (keeps the real title / tabs / toolbar around it). `bordered` wraps it in
// its own table card; turn it off when it sits inside an existing card.
export default function InlineTableSkeleton({ isDarkMode, rows = 8, cols = 5, bordered = true }) {
    const baseColor = isDarkMode ? "#334155" : "#e2e8f0";
    const highlightColor = isDarkMode ? "#475569" : "#f1f5f9";

    const inner = (
        <>
            <div className={`px-4 py-3 ${isDarkMode ? "bg-slate-700/40" : "bg-slate-50"}`}>
                <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
                    {Array.from({ length: cols }).map((_, c) => (
                        <Skeleton key={c} height={14} />
                    ))}
                </div>
            </div>
            <div className={`divide-y ${isDarkMode ? "divide-slate-700" : "divide-slate-100"}`}>
                {Array.from({ length: rows }).map((_, r) => (
                    <div key={r} className="px-4 py-3.5">
                        <div className="grid gap-4 items-center" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
                            {Array.from({ length: cols }).map((_, c) => (
                                <Skeleton key={c} height={14} width={c === 0 ? "80%" : "60%"} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );

    return (
        <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
            {bordered ? (
                <div className={`rounded-xl border overflow-hidden ${isDarkMode ? "bg-slate-800/60 border-slate-700" : "bg-white border-slate-200"}`}>
                    {inner}
                </div>
            ) : inner}
        </SkeletonTheme>
    );
}
